import { render, staticRenderFns } from "./TaskHistory.vue?vue&type=template&id=524aaf59&scoped=true&"
import script from "./TaskHistory.vue?vue&type=script&lang=js&"
export * from "./TaskHistory.vue?vue&type=script&lang=js&"
import style0 from "./TaskHistory.vue?vue&type=style&index=0&id=524aaf59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524aaf59",
  null
  
)

export default component.exports